// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__2RpV7","dense":"_type_dense__2N8f-","card":"_type_card__1wjPr","circle":"_type_circle__g9Omp","action":"_type_action__35vDq","icon":"_type_icon__3USJr"};